/* eslint-disable import/prefer-default-export */
import * as Yup from 'yup';

const addUserSchema = Yup.object().shape({
  name: Yup.string()
    .required('Required'),
  email: Yup.string()
    .email('Invalid email')
    .required('Required'),
  password: Yup.string()
    .min(8, 'Too Short!')
    .required('Required'),
});
const addBannerSchema = Yup.object().shape({
  ads: Yup.mixed().required('A file is required'),
});
const addHomeAdsSchema = Yup.object().shape({
  ads: Yup.mixed().required('A file is required'),
});
export {
  addUserSchema,
  addBannerSchema,
  addHomeAdsSchema,
};
